import React from "react";
import "../../Styles/certified/zuci.css";

export default function Finzly() {
  return (
    <>
      <div className="zuci-certified-details-section">
        <div className="zuci-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="zuci-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="zuci-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="zuci-certified-badge"
            />
            <div className="zuci-certified-company-names">
              <a href="https://www.zucisystems.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/zuci/zuci.png"
                alt="Walkzero Logo"
                className="zuci-certified-company-logo"
              />
            </a>
              <h1 className="zuci-certified-full-name">
              Zuci Systems (India) Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="zuci-certified-details-right">
            <img
              src="/assets/zuci/zuci_2.png"
              alt="Finzly Office"
              className="zuci-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="zuci-certified-description">
          <h2>
            Why Zuci Systems (India) Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            Zuci Systems is a global digital engineering and technology solutions company specializing in Digital Engineering, Quality Engineering, Data and Analytics,  AI, and digital transformation services. Founded in 2016, Zuci partners with organizations across industries to build innovative, scalable, and customer-centric technology solutions.


          </p>
          <p>
            With a people-first culture at its core, Zuci is committed to fostering an inclusive and collaborative workplace where employees are empowered to learn, grow, and contribute meaningfully. The organization places strong emphasis on diversity, equity, and inclusion, employee well-being, continuous learning, and creating opportunities for professional and personal development.
          </p>
          
          
        </div>
        
        <div className="zuci-certified-info-cards">
          <div className="zuci-certified-info-card">
            <div className="zuci-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">563 Employees</div>
          </div>
          <div className="zuci-certified-info-card">
            <div className="zuci-certified-info-title">INDUSTRY</div>
            <div className="zuci-certified-info-value">IT

</div>
          </div>
          <div className="zuci-certified-info-card">
            <div className="zuci-certified-info-title">CONNECT</div>
            <div className="zuci-certified-info-icons">
              <span className="zuci-certified-icon-round">
                <a href="https://www.zucisystems.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="zuci-certified-icon-round">
                <a href="https://www.linkedin.com/company/zuci-systems/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="zuci-certified-icon-round">
                <a href="https://www.facebook.com/zucisystems/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="zuci-certified-info-card">
            <div className="zuci-certified-info-title">LOCATION (HQ)</div>
            <div className="zuci-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="zuci-certified-recognition-section">
          <h2 className="zuci-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="zuci-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="zuci-certified-recognition-image"
            />
          </div>
          <div className="zuci-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="zuci-certified-life-section">
          <h2 className="zuci-certified-life-title">
            Life at   Zuci Systems (India) Private Limited
          </h2>
          <div className="zuci-certified-life-gallery">
            <div className="zuci-certified-life-col">
              <img src="/assets/zuci/zuci_1.png" alt="Office 1" className="zuci-certified-life-img" />
              <img src="/assets/zuci/zuci_3.png" alt="Team 1" className="zuci-certified-life-img" />
            </div>
            <div className="zuci-certified-life-col zuci-certified-life-center">
              <img src="/assets/zuci/zuci_5.png" alt="Main Office" className="zuci-certified-life-img zuci-certified-life-img-large" />
            </div>
            <div className="zuci-certified-life-col">
              <img src="/assets/zuci/zuci_6.png" alt="Office 2" className="zuci-certified-life-img" />
              <img src="/assets/zuci/zuci_4.png" alt="Team 2" className="zuci-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
